const autoNgTemplateLoaderTemplate1 = require('./settingsEdgeCompute.html');

import angular from 'angular';
import controller from './settingsEdgeComputeController';

angular.module('shbdeployer.app').component('settingsEdgeComputeView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
